var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"my-3",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"text-left",attrs:{"sm":_vm.labelWidth}},[_c('label',{staticClass:"mb-0 align-middle font-weight-bold"},[_vm._v(_vm._s(this.label))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":_vm.inputWidth}},[_c('span',{staticClass:"FITTextContent"},[_vm._v(_vm._s(_vm.content))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a95b0a0","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/FITTextRow.vue
// module id = null
// module chunks = 